<article *ngIf="gender">
    <app-muted-stackedbar [data]="gender"></app-muted-stackedbar>
</article>
